import { render, staticRenderFns } from "./AdminRevenueChart.vue?vue&type=template&id=89f91aec&scoped=true&"
import script from "./AdminRevenueChart.vue?vue&type=script&lang=js&"
export * from "./AdminRevenueChart.vue?vue&type=script&lang=js&"
import style0 from "./AdminRevenueChart.vue?vue&type=style&index=0&id=89f91aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f91aec",
  null
  
)

export default component.exports